import * as React from "react";
import { FaFacebookF } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import Container from "./styled";

export default function Header() {
  return (
    <Container name="header">
      {/* Logo SeguroBici */}
      <h1>
        <a href="/">
          <img alt="Logo de SeguroBici" src="images/logos/segurobici.svg"></img>
        </a>
      </h1>
      {/* Numeros de telefono Social Media Container */}
      <div className="numerosSocialMedia">
        {/* Numeros de telefono */}
        <p>0810-220-2373</p>
        <p>(011) 5263-2373</p>
        {/* Social Media Container */}
        <div className="socialMediaContainer">
          {/* Instagram Buttom */}
          <a href="https://www.instagram.com/segurobici/" target="_blank">
            <BsInstagram />
          </a>
          {/* Facebook Button */}
          <a href="https://www.facebook.com/SeguroBici/" target="_blank">
            <FaFacebookF />
          </a>
        </div>
      </div>
    </Container>
  );
}
